(() => {
  function bindWidget(widget) {
    const root = widget.shadowRoot;
    if (!root || root.querySelector('[data-ml-chat-hit-area]')) return;
    const style = document.createElement('style');
    style.dataset.mlChatHitArea = '';
    style.textContent = ':host([data-state="closed"]) #chatty-iframe { clip-path: circle(32px at calc(100% - 32px) calc(100% - 32px)) !important; }';
    root.appendChild(style);
  }
  document.querySelectorAll('.chatty-widget').forEach(bindWidget);
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('.chatty-widget')) bindWidget(node);
        node.querySelectorAll('.chatty-widget').forEach(bindWidget);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
